import Image from "next/image";
import assetLoader from "@utils/internalImageLoder";
import { cn } from "@utils/utils";
import styles from "../../organisms/SearchComponent/SearchComponent.module.scss";

interface SearchTriggerProps {
  onClick: () => void;
  className?: string;
  customIconSrc?: string; // optional custom icon path
  label?: string;         // optional custom label
}

export const SearchTrigger = ({
  onClick,
  className,
  customIconSrc,
  label = "What are you looking for?",
}: SearchTriggerProps) => {
  return (
    <div className={cn(styles.searchTrigger, className)} onClick={onClick}>
      <Image
        src={customIconSrc || `${assetLoader()}/icons/search.svg`}
        alt="Search Icon"
        width={24}
        height={24}
        loading="lazy"
      />
      <span>{label}</span>
    </div>
  );
};

export default SearchTrigger;
